import { createFileRoute } from '@tanstack/react-router';
import { SequencesContentV2 } from '@/features/sequences/components/list/SequencesContentV2';

export const Route = createFileRoute('/_dashboard/sequences')({
  component: SequencesContentV2,
});
